import { Component, inject, QueryList, ViewChild, ViewChildren, Input } from '@angular/core';
import { CdkDragDrop, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { DropListRegistryService } from "../../cockpitDesigner/drop-list-registry.service";


@Component({
    selector: 'app-cockpit-empty-cell.component',
    styleUrls: ['empty-cell-component.css'],
    templateUrl: 'empty-cell-component.html',
    imports: [DragDropModule]
})


export class CockpitEmptyCellButton{

  private registry = inject(DropListRegistryService);
  @Input() columnIndex  = 0;
 @ViewChild(CdkDropList) cellList!: CdkDropList;
 item = {
  id:'test',
  other: 'test'
 }

  getConnectedLists() {
    return this.registry.getAll();
  }

  ngAfterViewInit() {
    this.registry.register(this.cellList);
  }

   drop(event: CdkDragDrop<any>) {
  if (event.previousContainer !== event.container) {
    console.log("dropped item", event)
    // item dragged from sidebar into this grid cell
    //targetItem.id = event.previousContainer.data.type;
  }
}

}